module.exports = "/wp-content/themes/onnit/script/cart/dist/abFocusShotMultiOverride-8e6349b8.png";